<template>
  <div class="content">
    <div class="content-box">
      <!-- <iframe id="frameDom" name="frame" src="http://localhost:8080/phone/index.html?surveyId=xqLNoW9c&amp;versionId=14319&amp;companyid=1&amp;isTest=true&amp;testId=501483623816364032&amp;isPhone=true" frameborder="0" width="100%" height="100%"></iframe> -->
      <div class="iframe-box">
        <iframe
          id="frameDom"
          name="frame"
          :src="getTestUrl + '&isPhone=true&template=true&noTip=true'"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
      <div class="status-box">
        <img class="status" src="/entrance/img/template-library/phone-status-nav.png" />
      </div>
      <img class="handset" src="/entrance/img/template-library/iPhoneXWhiteTop.png" />
    </div>
    <div class="code-box">
      <div class="r">
        <img src="/entrance/img/template-library/code-icon.png" />
        <span>扫码预览</span>
      </div>
      <p>仅供预览 请勿传播</p>
      <div class="code-img-box">
        <vue-qr :margin="10" :text="getTestUrl" logoSrc="/entrance/img/logo-mini.png"></vue-qr>
      </div>
      <!-- <el-divider></el-divider> -->
      <!-- <p>将于12:16失效</p> -->
      <!-- <div class="r">
        <img src="/entrance/img/template-library/refresh.png"/>
        <span>立即刷新</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getPreviewUrl } from '@/assets/js/utils'
import VueQr from 'vue-qr'

export default {
  name: 'phoneModule',
  components: {
    VueQr
  },
  props: {
    surveyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    getTestUrl() {
      return this.previewUrl + '&isTest=true'
    },
    previewUrl() {
      // return getPreviewUrl('phone', { surveyId: this.surveyId })
      return getPreviewUrl('mobile', { surveyId: this.surveyId })
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.content {
  width: 497px;
  height: 738px;
  margin: 0 auto;
  background-image: url(/entrance/img/template-library/iPhoneXWhite.png);
  background-size: 100% 100%;
  border: 1px solid transparent;
  @apply relative box-border;
  .content-box {
    width: 322px;
    height: 604px;
    margin-left: 87px;
    margin-top: 59px;
    border-radius: 34px;
    overflow: hidden;
    position: relative;
    .iframe-box {
      width: 322px;
      height: 583.5px;
      margin-top: 20.5px;
      @apply bg-white;
    }
    .handset {
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      width: 154.5px;
    }
    .status-box {
      width: 322px;
      height: 20.5px;
      position: absolute;
      top: 0px;
      text-align: center;
      line-height: 20.5px;
      .status {
        width: 280px;
      }
    }
  }
  .code-box {
    width: 100px;
    // height: 233px;
    padding: 18px 16px 16px 16px;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.08);
    right: -97px;
    top: 80px;
    @apply text-center rounded-medium absolute bg-white;
    .r {
      line-height: 16px;
      @apply h-4;
    }
    span,
    img {
      display: inline-block;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .r:first-child {
      img:first-child {
        width: 16px;
        height: 15.56px;
        opacity: 0.85;
      }
      span:nth-child(2) {
        color: rgba($color: #000000, $alpha: 0.85);
        margin-left: 6px;
        @apply font-normal text-medium;
      }
    }
    p {
      color: rgba($color: #000000, $alpha: 0.45);
      @apply font-normal text-small mt-2;
    }
    .code-img-box {
      width: 100px;
      height: 100px;
      margin-top: 16px;
      img {
        @apply w-full;
      }
    }
    ::v-deep .el-divider--horizontal {
      margin: 15px 0 8px 0 !important;
    }
    .r:last-child {
      @apply mt-2 cursor-pointer;
      img:first-child {
        @apply w-4 h-4;
      }
      span:last-child {
        @apply font-normal text-small text-theme ml-1;
      }
    }
  }
}
</style>
